module.exports = __webpack_public_path__ + "static/item--ac--f7@3x.356867dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--ac--f7@3x.png
// module id = 625
// module chunks = 126511778744290